import React, {Fragment, useState, useEffect} from 'react'
import axios from 'axios';
import { Title, HeaderList, Cardlist,Container } from './styles'
import EbookCard from '../EbookCard'
import globals from 'react-global-configuration';

export const ListOfResources = (props) => { 
    
    const _URL_REST = globals.get('_URL_REST');
    

    const [data, setData] = useState(null);
    

    useEffect(() => {
        //axios wait
        async function fetchData() {
          const result = await axios(
            `${_URL_REST}/getrecursos/${props.idevento}`,
        );
        setData(result.data);
        }
        fetchData();
    }, [_URL_REST,props.url,props.idevento]);

    if (!data) {
        return <div></div>  
    }
    
    return (
        <Fragment>
            <Container>
                <HeaderList>
                    <Title>{props.title}</Title>
                </HeaderList>
                <Cardlist >
                    {
                        data
                        .map(audiocard => 
                            <EbookCard  key={audiocard.id} id={audiocard.id} cover={audiocard.image} source={audiocard.file} title={audiocard.title} res={audiocard.resum} />)
                    }
                </Cardlist>
                <div></div>
            </Container>
        </Fragment>
    )
}
